import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet-async";

import Navbar from "../components/homepage/Navbar";
import AgricultureDrone from "../components/productPage/AgricultureDrone";
import DroneCategorie from "../components/productPage/DroneCategorie";
 
import DroneFaq from "../components/productPage/DroneFaq";
import { Header, Footer } from "../shared";
// import QueryPopup from "../components/common/QueryPopup";

const ProductPage = () => {
  const [showPopup, setShowPopup] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);

    setTimeout(() => {
      setShowPopup(true);
    }, 500);
  }, []);

  return (
    <>
      <Helmet>
        <title>
          Drone Planet – Buy Best Drones & Drones Parts in India
        </title>

        <meta
          name="description"
          content="Buy best agriculture, photography, survey, inspection and nano drones and parts in India. Compare and shop drones at best price on Drone Planet."
        />

        <link
          rel="canonical"
          href="https://api.droneplanet.in/product/all-drone"
        />

        {/* Open Graph */}
        <meta property="og:type" content="website" />
        <meta
          property="og:title"
          content="Drone Planet – Buy Best Drones & Drones Parts in India"
        />
        <meta
          property="og:description"
          content="Buy best agriculture, photography, survey, inspection and nano drones and parts in India."
        />
        <meta
          property="og:url"
          content="https://api.droneplanet.in/product/all-drone"
        />
        <meta
          property="og:image"
          content="https://api.droneplanet.in/static/media/DronePlanet_Logo-removebg.265956edb16672c717e2.png"
        />

        {/* Twitter */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content="Drone Planet – Buy Best Drones & Drones Parts in India"
        />
        <meta
          name="twitter:description"
          content="Buy best agriculture, photography, survey, inspection and nano drones and parts in India."
        />
        <meta
          name="twitter:image"
          content="https://api.droneplanet.in/static/media/DronePlanet_Logo-removebg.265956edb16672c717e2.png"
        />
      </Helmet>

      <div>
        <div className="bg_darkblue">
          <Header />
        </div>

        <DroneCategorie />
        <AgricultureDrone />
        <DroneFaq />
        <Footer />

        {/* <QueryPopup show={showPopup} onClose={() => setShowPopup(false)} /> */}
      </div>
    </>
  );
};

export default ProductPage;